import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Number = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  margin-right: 4px;
  min-width: 10px;
`;

export const StarWrapper = styled.div`
  max-width: 14px;
  min-width: 14px;
  max-height: 14px;
  min-height: 14px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Bar = styled.div`
  width: 150px;
  height: 17px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.innerProduct.gray};
  border-radius: 4px;
  position: relative;
  z-index: 0;
  ${mq(1200)} {
    width: 120px;
  }
  ${mq(992)} {
    width: 280px;
  }
`;

export const PercentageNumber = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

export const Progress = styled.div`
  position: absolute;
  border-radius: 4px;
  top: 0;
  left: 0;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.innerProduct.progress};
  z-index: 1;
`;
